import React, { Component } from "react";
import { Button, Form, Icon, Table, Grid, Card } from "tabler-react";
import { Crud_Catalogos, Crud_error } from '../../../herramientas/Crud_Catalogos';
import { timingSafeEqual } from "crypto";
class  Movimientostipo extends Component {
  constructor(props) {
    super(props);
    this.state = {
                      id: "",
                  accion: this.props.accion, //'nuevo'// modificar, nuevo
                  Movimientostipo:[],
                  search:""
                 };
                               this.Movimientostipo= [];
                          this.plataformasObject= [];
                         this.checarMovimientostipo= 0;      //temporal render
                   this.idplataformasMovimientostipo= 0; //temporal render
              this.plataformasMovimientostipoObject= [];
                          this.MovimientostipoArray= [];
  }

  componentDidMount =() => {
    if(this.state.accion !== 'nuevo'){
      this.setState({id: this.props.elementos.id});
      this.plataformasObject= this.props.elementos;
      this.getfuntion("get", "", "", "plataformasmovimientostipo/plataforma/"+this.props.elementos.id,"Movimientostipo")
    }else{}
  }
getfuntion = (metodo="get", obj=[], id="", catalogo="", stateVar= "", hiddenModl="") =>{
  Crud_Catalogos(catalogo, "plataformas", metodo, id, obj,"" , stateVar, hiddenModl, []).then((returnVal) => {
      /**
       * filtro de variables
       */
      switch (metodo) {
        case "get":
          {
            if (stateVar === "Movimientostipo"){ this.Movimientostipo= returnVal; this.setState({ Movimientostipo: returnVal }); }
          }
          break;
        case "post":
          {
           if (stateVar === "Movimientostipo"){
              this.Movimientostipo.push(returnVal);
              this.setState({ Movimientostipo: this.Movimientostipo });
            }
          }
          break;
        case "delete":
          {
            if (stateVar === "Movimientostipo"){
              this.Movimientostipo.map((elemento, index)=>
                {if(id === elemento.id){
                  this.Movimientostipo.splice(index, 1);
                }}
              )
              this.setState({ Movimientostipo: this.Movimientostipo })
            }
          }
            break;
        default:
          break;
      }
    }).catch(err =>{
      if( err.response ){
        console.log(err.response);
      }else{
        /**
         * Error
         */
        console.log("Error desconocido ....");
        console.log(err)
      }
  })
}

  changeMovimientostipo =(MovimientostipoIndex, OtdId, OtdStatus) => {
      this.plataformasMovimientostipoObject={
        "idPlataforma": this.plataformasObject,
        "idMovimientoTipo": this.props.stor.movimientosTipo_object.filter(word => word.nombre.toUpperCase().includes(this.state.search.toUpperCase())).sort()[MovimientostipoIndex]
      }

      this.MovimientostipoArray[MovimientostipoIndex].estatus === 1 ?
      this.getfuntion("delete", "", this.MovimientostipoArray[MovimientostipoIndex].id, "plataformasmovimientostipo", "Movimientostipo")
      :
      this.getfuntion("post",this.plataformasMovimientostipoObject, "", "plataformasmovimientostipo", "Movimientostipo");
    }
    checkedMovimientostipo =(indice) =>{
      return this.MovimientostipoArray[indice].estatus
    }
    checarMovimientostipos =(estatus, id) =>{
      this.MovimientostipoArray.push({ estatus: estatus, id: id })
    }
    checarMovimientostipoTem =(valor) =>{
      this.checarMovimientostipo=valor;
    }
    searching =(event) =>{
      this.setState({ search: event.target.value })
    }
    cleanArrayList =() =>{
      this.MovimientostipoArray= [];
    }
  render(){
    return (
      <div>
        {/**
          *   Elementos de plataformas
          */
        }
        { this.cleanArrayList() }
        { this.state.accion === "modificar" ?
          <div>
            <Grid.Row>
              <Grid.Col>
                <Card
                  title="Tipo Movimiento"
                  isCollapsible={false}
                  //isClosable
                  isCollapsed={ false}
                  options={ <Form.Group>
                              <Form.Input
                                className="mb-3"
                                icon="search"
                                placeholder="Buscar Tipo movimiento..."
                                position="append"
                                onChange={this.searching}
                              />
                            </Form.Group>}
                  body={
                    <div>
                      <Form.Group>
                        <Table
                          cards={true}
                          striped={true}
                          responsive={true}
                          className="table-vcenter"
                        >
                          <Table.Header>
                            <Table.ColHeader>ID</Table.ColHeader>
                            <Table.ColHeader>Nombre</Table.ColHeader>
                            <Table.ColHeader>Status</Table.ColHeader>
                          </Table.Header>
                          <Table.Body>
                            {
                              this.props.stor.movimientosTipo_object.filter(word => word.nombre.toUpperCase().includes(this.state.search.toUpperCase())).sort().map((elemento, index) =>
                                <Table.Row>
                                  <Table.Col>{ elemento["id"] }</Table.Col>
                                  <Table.Col>{ elemento["nombre"] }</Table.Col>
                                  { this.checarMovimientostipoTem(0)}
                                  { this.idplataformasMovimientostipo="" }
                                  {
                                    this.state.Movimientostipo.map((elemMovimientostipo, ind) =>
                                    {
                                      if(elemMovimientostipo.idMovimientoTipo.id === elemento.id){
                                        { this.checarMovimientostipoTem(1)}
                                        this.idplataformasMovimientostipo=elemMovimientostipo.id;
                                      }
                                    })
                                  }
                                  { this.checarMovimientostipos(this.checarMovimientostipo, this.idplataformasMovimientostipo)}
                                  <Table.Col><Form.Switch type="Checkbox" name="toggle" value="option1"
                                                          checked={ this.checkedMovimientostipo(index) }
                                                          className={"disabled"}
                                                          onChange={ () => this.changeMovimientostipo(index, elemento["id"], this.checarMovimientostipo) } /></Table.Col>
                                </Table.Row>
                              )
                            }
                          </Table.Body>
                        </Table>
                      </Form.Group>
                    </div>
                  }
                />
              </Grid.Col>

            </Grid.Row>
          </div>
        :null}
      </div>
    )
  }
}

export default Movimientostipo
